<!--
  Иконка датчика телеметрии: узел с сигналом
  Используется в настройках параметров датчика
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="3" :stroke="stroke" stroke-width="2" />
    <path
      d="M12 3V6M12 18V21M3 12H6M18 12H21"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M5.64 5.64L7.76 7.76M16.24 16.24L18.36 18.36M18.36 5.64L16.24 7.76M7.76 16.24L5.64 18.36"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "SensorIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
